<template>
  <div class="kiosks-sidebar">
    <list-widget
      :items="kiosks.items"
      addNewRouteName="add-kiosk"
      :addNewTitle="$t('kiosk.add_kiosk')"
      routeName="kiosk"
      :hideHeader="true"
      :changeRoute="true"
    >
      <template slot="item-template" slot-scope="{ item }">
        <router-link
          v-if="item.isNewRoute"
          class="items-container__item item add-new-item"
          :to="{ name: 'add-kiosk' }"
        >
          <div class="item__row item__title">
            <span>{{ item.name }}</span>
          </div>
        </router-link>
        <router-link
          v-else
          class="items-container__item item"
          :to="{ name: 'kiosk', params: { id: item.id }, query: $route.query }"
        >
          <div class="item__row item__title">
            <span>
              <span
                v-if="item.headwind_device_number"
                class="status-dot"
                :class="item.headwind_status || 'unknown'"
              ></span>
              {{ item.name }}
            </span>
          </div>
          <div class="item__statusbar">
            <span class="filling" :style="{ 'background-color': '#D8D8D8' }"></span>
          </div>
          <div class="item__row item__subtitle">
            <span>{{ [item.description, kioskTypeLabel(item.kiosk_type)].filter(Boolean).join(' | ') }}</span>
          </div>
        </router-link>
      </template>
      <template v-if="hasMore" slot="footer">
        <a class="load-more-link" @click="loadMore">{{ $t('common.load_more') }}</a>
      </template>
    </list-widget>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ListWidget from 'common/ListWidget';

export default {
  components: {
    ListWidget,
  },
  computed: {
    ...mapGetters({
      kiosks: 'kiosks/kiosks/kiosks',
      user: 'user/user/user',
    }),
    hasMore() {
      return this.kiosks.items.length < this.kiosks.total;
    },
  },
  created() {
    this.fetchKiosks();
  },
  methods: {
    kioskRoute(item) {
      return { name: 'kiosk', params: { id: item.id }, query: { keyword: this.$route.query.keyword } };
    },
    kioskTypeLabel(type) {
      const labels = { guest_parking_kiosk: 'Guest parking kiosk', regular: 'Guest parking kiosk', franky: 'Franky' };
      return labels[type] || type;
    },
    fetchKiosks() {
      const { keyword, kiosk_type: kioskType } = this.$route.query;
      this.$store.dispatch('kiosks/kiosks/fetch', { keyword, kioskType, user: this.user });
    },
    loadMore() {
      const { keyword, kiosk_type: kioskType } = this.$route.query;
      this.$store.dispatch('kiosks/kiosks/loadMore', { keyword, kioskType, user: this.user });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/blocks/status-dot.scss';

.kiosks-sidebar {
  position: sticky;
  top: 0;
  max-height: 100vh;
  overflow-y: auto;

  @media screen and (max-width: 759px) {
    position: static;
    max-height: none;
    overflow-y: visible;
  }
}

.load-more-link {
  display: block;
  text-align: center;
  padding: 10px;
  cursor: pointer;
  color: var(--brand-orange);
  font-size: 13px;

  &:hover {
    opacity: 0.8;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/kiosks/Sidebar.vue